/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'statistics': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M914.414 229.95c-21.558-28.743-53.895-64.673-86.232-100.603-35.93-32.336-71.86-64.673-100.603-86.231C677.277 7.186 652.126 0 637.754 0H141.923C98.807 0 62.877 35.93 62.877 79.046v858.722c0 43.116 35.93 79.046 79.046 79.046H874.89c43.116 0 79.046-35.93 79.046-79.046V319.775c0-14.371-3.593-39.522-39.523-89.824zm-132.94-53.894c32.337 28.744 53.894 57.488 71.86 82.639H698.834V104.196c25.151 17.965 50.302 39.523 82.639 71.86zm111.382 765.305c0 7.186-7.186 14.372-14.372 14.372H141.923c-7.186 0-14.372-7.186-14.372-14.372V82.64c0-7.186 7.186-14.372 14.372-14.372H634.16v222.765c0 17.964 14.372 32.336 32.337 32.336h222.765v617.993z"/><path pid="1" d="M170.667 812.014h675.48v82.639h-675.48zm488.645-168.87h82.639v125.754h-82.639zm-125.754-168.87h82.638v294.624h-82.638zM407.804 600.028h82.638v168.87h-82.638zM282.049 348.52h82.639V768.9h-82.639z"/>'
  }
})
